import { useQuery } from "@tanstack/react-query";

import { getGroupDetails } from "../services/group.services";
import { Group } from "../types/group.types";
import { GROUPS_QUERY_KEYS } from "../queryKeys";

export const useGroupDetailsQuery = (entityId: number | undefined, groupId: number | undefined) => {
  return useQuery<Group>({
    queryKey: GROUPS_QUERY_KEYS.groupDetails(Number(groupId)),
    queryFn: () => getGroupDetails(Number(entityId), Number(groupId)),
    enabled: !!entityId && !!groupId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
